function Distributor() {
  const self = this;

  function compare(entry1, entry2) {
    if (entry2.amount < entry1.amount) {
      return -1;
    }
    if (entry2.amount > entry1.amount) {
      return 1;
    }
    return 0;
  }

  self.distributionByStrategy = function (strategy, assets) {

    const totalSumOfAssets = assets.map(asset => asset.amount).reduce((memo, assetAmount) => {
      memo += assetAmount;
      return memo;
    }, 0);

    const assetsByFund = assets.reduce((memo, asset) => {
      memo[asset.fund.isin] = asset.amount;
      return memo;
    }, {});

    const strategyWithAmounts = strategy.map(s => {
      return Object.assign(s, {amount: (totalSumOfAssets * s.percentage) / 100})
    })

    let toBuy = strategyWithAmounts.map(sa => {
      const found = assets.find(asset => asset.fund.isin === sa.isin)
      return Object.assign({}, {
        isin: sa.isin,
        amount: (sa.amount - (found ? found.amount : 0))
      })
    }).filter(entry => entry.amount > 0).sort(compare)

    let toSell = assets.map(asset => {
      const found = strategyWithAmounts.find(s => s.isin === asset.fund.isin)
      return Object.assign({}, {
        isin: asset.fund.isin,
        amount: asset.amount - (found ? found.amount : 0),
        unitAmount: asset.unitAmount
      })
    }).filter(entry => entry.amount > 0).sort(compare)

    return toSell.reduce((memo, sell) => {
      return toBuy.reduce((memo, buy) => {
        const transactionSum = sell.amount > buy.amount ? buy.amount : sell.amount
        if (transactionSum > 0) {
          const percentage = Math.round(transactionSum * 100.0 / assetsByFund[sell.isin])
          memo.push(
            Object.assign({}, {
              from: sell.isin,
              to: buy.isin,
              percentage: percentage,
              units: parseFloat((sell.unitAmount * percentage / 100.0).toFixed(3))
            })
          )
        }
        sell.amount -= transactionSum
        buy.amount -= transactionSum
        return memo;
      }, memo)
    }, []).filter(row => row.percentage > 0)
  }
}
